import React from 'react';
import { MuiThemeProviderProps } from './MuiThemeProvider.types';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { publicRuntimeConfig } from '@repo/config';
import { IQTheme } from './themes/iq';
import { RunaTheme } from './themes/runa';
import { AppRunningPlatform } from '@repo/utils';

const options = publicRuntimeConfig.app.runningPlatform === AppRunningPlatform.RUNA ? RunaTheme : IQTheme;

const theme = createTheme(options);

const MuiThemeProvider: React.FC<MuiThemeProviderProps> = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default React.memo(MuiThemeProvider);
